<div
  class="footer-area text-center bg-white border-top-radius box-shadow"
  [class.card-borderd-theme]="themeService.isCardBorder()"
  [class.component-dark-theme]="themeService.isDark()"
  [class.card-border-radius]="themeService.isCardBorderRadius()"
>
  <p>© P2C Rewards is Proudly Owned by <a href="" class="fw-semibold" target="_blank">Branzee</a></p>
</div>
